module.exports = __webpack_public_path__ + "static/media/20201219_140214_450_IMG_3486.1b6f0a45.jpg";